import { useMsal } from '@azure/msal-react';
import React, { useContext, useState } from 'react';
import useAddUserAgreement from '../requests/useUpdateUserAgreement';
import { UserContext, UserProfile, UserStatus } from './UserAccess/UserContext';

const UserAgreementModal = () => {
  const userStatus = useContext<UserStatus>(UserContext);
  const userProfile = userStatus.user as UserProfile;
  const userAgreementUrl = userProfile?.userAgreementInfo.url;
  const [showModal, setShowModal] = useState(!userProfile?.userAgreementInfo.hasAcceptedUserAgreement && !userProfile?.hasConflictingSignInMethod);
  const { instance } = useMsal();

  const userId = userProfile?.id ?? '0';

  const updateUserAgreement = useAddUserAgreement(userId, {
    onSuccess: () => {
      setShowModal(false);
    },
    onError: () => {
      userAgreementDeclined();
    }
  });

  const userAgreementDeclined = () => {
    instance.logoutRedirect();
  };

  const userAgreementAccepted = async () => {
    await updateUserAgreement.request();
    setShowModal(false);
  };

  if (!showModal) return null;

  return <>
    <div className="modal fade show d-block" tabIndex={-1} role="dialog" aria-labelledby="userAgreementLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h2 className="modal-title ka-blue" id="userAgreementLabel">Terms and Conditions</h2>
          </div>
          <div className="modal-body text-center px-10" style={{ fontSize: '22px' }}>
            <p>
              By clicking "<span className="ka-blue"><strong>Accept</strong></span>," you confirm that you have read and agree to be bound by our <span className="ka-blue"><strong>Terms and Conditions</strong></span>.
            </p>
            <a href={userAgreementUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Terms &mdash; Kahler Automation
            </a>
          </div>
          <div className="modal-footer justify-content-center" style={{ borderTop: 'none', padding: '8px 16px' }}>
            <div className="me-auto">
              <button type="button"
                className="btn btn-link"
                onClick={userAgreementDeclined}
                data-dismiss="modal"
                style={{ fontSize: '16px' }}>
                <strong>Exit Constellation</strong>
              </button>
            </div>
            <div className="ms-auto">
              <button type="button"
                className="btn btn-link"
                onClick={userAgreementAccepted}
                data-dismiss="modal"
                style={{ fontSize: '16px' }}>
                <strong>Accept Terms</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="modal-backdrop fade show" />
  </>
};

export default UserAgreementModal;